import type { ComponentEvent } from '../../types/project';

export function getButtonOnClickActionId(events: ComponentEvent[] | undefined): string {
  return events?.find((event) => event.event === 'onClick')?.actionId ?? '';
}

export function assignButtonOnClick(events: ComponentEvent[] | undefined, actionId: string): ComponentEvent[] {
  const current = events ?? [];
  const firstOnClickIndex = current.findIndex((event) => event.event === 'onClick');
  if (!actionId) return current.filter((event) => event.event !== 'onClick');
  const nextEvent: ComponentEvent = { event: 'onClick', actionId };
  if (firstOnClickIndex < 0) return [...current, nextEvent];
  return current.flatMap((event, index) => {
    if (event.event !== 'onClick') return [event];
    return index === firstOnClickIndex ? [nextEvent] : [];
  });
}
